export function formatCurrency(num) {
  if (num == null) return '0';

  const sign = num < 0 ? '-' : '';
  const absNum = Math.abs(num);

  if (absNum >= 10000000) {
    return sign + (absNum / 10000000).toFixed(1) + 'Cr'; // Crores
  } else if (absNum >= 100000) {
    return sign + (absNum / 100000).toFixed(1) + 'L'; // Lakhs
  } else if (absNum >= 1000) {
    return sign + (absNum / 1000).toFixed(1) + 'K'; // Thousands
  }

  return sign + absNum.toLocaleString();
}
export const formatCurrencywithcommas = (amount: number) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(amount);
};
